import {Injectable} from '@angular/core';
import {AuthService} from '../authentication/auth.service';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  sessionKey: string = this.authService.getSessionKey();
  globalKey:string = environment.globalEncKey;

  constructor(private authService: AuthService) {
  }


  enc(obj: any, useGlobalKey = false) {
    
    let key = this.sessionKey;
    if(useGlobalKey){
      key = this.globalKey;
    }
    const b64 = CryptoJS.AES.encrypt(JSON.stringify(obj),key ).toString();
    const e64 = CryptoJS.enc.Base64.parse(b64);
    const eHex = e64.toString(CryptoJS.enc.Hex);
    return eHex;
  }

  dec(cipherText, useGlobalKey = false) {

    let key = this.sessionKey;
    if(useGlobalKey){
      key = this.globalKey;
    }

    const reb64 = CryptoJS.enc.Hex.parse(cipherText);
    const bytes = reb64.toString(CryptoJS.enc.Base64);
    const decrypt = CryptoJS.AES.decrypt(bytes,key);
    const plain = decrypt.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plain);
  }
}
